import { combineReducers, Reducer } from "@reduxjs/toolkit";
import additionalProductsReducer from "./additionalProductsReducer";
import customerReducer from "./customerReducer";
import fwaReducer from "./fwaReducer";
import hardwareReducer from "./hardwareReducer";
import phoneNumbersReducer from "./phoneNumbersReducer";
import subscriptionStepsReducer from "./subscriptionStepsReducer";
import salesAgentReducer from "./salesAgentReducer";
import selectedAgentReducer from "./selectedAgentReducer";
import { FORM_ID } from "../../../../../constants";
import { createReducer as createFormsReducer } from "../../../rapidform";

const reducer: Reducer = combineReducers({
    shops: (state = []) => state,
    salesAgent: salesAgentReducer,
    salesAgents: (state = []) => state,
    selectedAgent: selectedAgentReducer,
    firebaseUrl: (state: string | null = null) => state,
    customer: customerReducer,
    fwa: fwaReducer,
    phoneNumbers: phoneNumbersReducer,
    additionalProducts: additionalProductsReducer,
    subscriptionSteps: subscriptionStepsReducer,
    hardware: hardwareReducer,
    [FORM_ID.CUSTOMER_IDENTIFICATION]: createFormsReducer(FORM_ID.CUSTOMER_IDENTIFICATION),
    [FORM_ID.CREDIT_CHECK]: createFormsReducer(FORM_ID.CREDIT_CHECK),
    [FORM_ID.CUSTOMER_CONTACT_INFO]: createFormsReducer(FORM_ID.CUSTOMER_CONTACT_INFO),
    [FORM_ID.CUSTOMER_PRODUCT_USER]: createFormsReducer(FORM_ID.CUSTOMER_PRODUCT_USER),
    [FORM_ID.EQUIPMENT_REGISTRATION]: createFormsReducer(FORM_ID.EQUIPMENT_REGISTRATION),
    [FORM_ID.IMEI_REGISTRATION]: createFormsReducer(FORM_ID.IMEI_REGISTRATION),
    [FORM_ID.RETAILER_LOOKUP]: createFormsReducer(FORM_ID.RETAILER_LOOKUP),
});

export default reducer;
